module.exports = __webpack_public_path__ + "img/return-orange.82a9cc28.svg";